import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';


ReactDOM.render(<App />,
  document.getElementById('root')
);

// font-family: 'M PLUS Code Latin', sans-serif;
// font-family: 'Montserrat', sans-serif;
// font-family: 'Open Sans Condensed', sans-serif;
// font-family: 'Roboto', sans-serif;
// font-family: 'VT323', monospace;